// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"rZ","skip_info":"sZ","skipped":"tZ","modify_order":"uZ","cancel_subscription_btn":"vZ","byb":"wZ","modify_order_outer":"xZ","byb_edit_btn":"yZ","modify_order_item":"zZ","cancel_copy_wrapper":"AZ","cancelled_copy":"BZ"};
    if(module.hot) {
      // 1738064243483
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  